<template>
  <footer class="app-footer">
    <div class="footer-container">
      <div class="info-grid">
        <div class="info-section">
          <h2>SELECT YOUR DRAW</h2>
          <p>
            We welcome you to register and choose from our extensive list of international Lucky Numbers draws. Numerous Lucky Numbers draws take place on a daily basis offering you the chance to win every day of the week. To begin, select which draw you would like to play by clicking on the "BET NOW" button.
          </p>
        </div>

        <div class="info-section">
          <h2>CHOOSE YOUR WINNING NUMBER</h2>
          <p>
            You can improve your odds by choosing to predict the outcome of 1, 2, 3 or 4 numbers from a draw from the "BET TYPE" option. You can also bet on the outcome of the bonus ball in some draws. Select the numbers you wish to choose for your prediction according to your chosen "BET TYPE".
          </p>
        </div>

        <div class="info-section">
          <h2>SUBMIT YOUR BET</h2>
          <p>
            Enter the amount of money you would like to bet with and submit your bet. Your wager history will display all your wagers and winnings. Also, all the draw results are displayed on this site for your convenience!
          </p>
        </div>
      </div>

      <div class="features-content">
        <div class="feature-item">
          <div class="icon-wrapper">
            <img :src="footerDraws" alt="Fast" width="60" height="60" />
          </div>
          <h3>Widest Selection</h3>
        </div>

        <div class="feature-item">
          <div class="icon-wrapper">
            <img :src="footerGlobalLotteries" alt="Lucky Numbers" width="60" height="60" />
          </div>
          <h3>Global Lucky Numbers</h3>
        </div>

        <div class="feature-item">
          <div class="icon-wrapper">
            <img :src="footerGreatMarkets" alt="Great Markets" width="60" height="60" />
          </div>
          <h3>Great Markets</h3>
        </div>

        <div class="feature-item">
          <div class="icon-wrapper">
            <img :src="footerFastResults" alt="Fast Results" width="60" height="60" />
          </div>
          <h3>Fast Results</h3>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="footer-bottom-container">
        <router-link to="/terms-and-conditions" class="footer-bottom-link">Terms & Conditions</router-link> | <router-link to="/wagers" class="footer-bottom-link">Wagers</router-link> | <span class="footer-bottom-version">Version: 1.0.1</span>
      </div>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { defineOptions } from 'vue'
import { useTheme } from '@/composables/useTheme'

defineOptions({
  name: 'AppFooter'
})

const { getAssetPath } = useTheme()

const footerDraws = computed(() => getAssetPath('footer', 'draws') || '/img/images/footer/01-draws.png')
const footerGlobalLotteries = computed(() => getAssetPath('footer', 'globalLotteries') || '/img/images/footer/02-global-lotteries.png')
const footerGreatMarkets = computed(() => getAssetPath('footer', 'greatMarkets') || '/img/images/footer/03-great-markets.png')
const footerFastResults = computed(() => getAssetPath('footer', 'fastResults') || '/img/images/footer/04-fast-results.png')
</script>
<style scoped>
.app-footer {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  margin-right: calc(-50vw + 50%);
}

.footer-container {
  max-width: 1280px;
  margin: 0 auto;
}

.info-grid {
  background: var(--footer-bg) !important;
  width: 100%;
  margin: 30px 0;
  padding: 32px 0;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.info-section {
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  gap: 16px;
}

.info-section h2 {
  color: var(--accent-color-text-heading);
  font-size: 20px;
  font-weight: 600;
  margin: 0;
}

.info-section p {
  color: var(--text-light);
  font-size: 16px;
  line-height: 1.6;
  margin: 0;
}

.features-content {
  width: 100%;
  margin: 0;
  padding: 32px 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 24px;
  background: var(--footer-bg2, #1D2636) !important;
}

.feature-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}

.icon-wrapper {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-white);
}
.icon-wrapper img {
  filter: var(--footer-icon-filter, none);
}
.feature-item h3 {
  color: var(--text-white);
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  white-space: nowrap;
}

.footer-bottom {
  width: 100%;
  padding: 16px 0;
  text-align: center;
}

.footer-bottom-link {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
}

.footer-bottom-version {
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
}


@media (max-width: 1024px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .footer-container {
    padding: 0 0px;
  }

  .features-content {
    display: none;
  }

  .info-grid {
    text-align: left;
  }

  .info-section h2 {
    font-size: 20px;
  }

  .info-section p {
    font-size: 14px;
  }
}

.info-section p {
  font-size: 14px;
  color: var(--text-white);
}
</style> 